import { render, staticRenderFns } from "./PointBody.vue?vue&type=template&id=71265766&scoped=true&"
import script from "./PointBody.vue?vue&type=script&lang=ts&"
export * from "./PointBody.vue?vue&type=script&lang=ts&"
import style0 from "./PointBody.vue?vue&type=style&index=0&id=71265766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71265766",
  null
  
)

export default component.exports